// src/pages/Home.js
import React from "react";
import HeroSection from "../components/HeroSection";
import AboutSection from "../components/AboutSection";
import ServicesSection from "../components/ServicesSection";
import OfficeCultureSection from "../components/OfficeCultureSection";

const Home = () => {
  return (
    <>
      <HeroSection />
      <AboutSection />
      <ServicesSection />
      <OfficeCultureSection />
    </>
  );
};

export default Home;
